import {isEmpty} from 'lodash';
import React from 'react';
import {color, type} from 'common/tokens';

const styles = {
  errorMessage: {
    ...type.meta,
    fontWeight: 'var(--ui-weight-regular)',
    marginTop: 6,
    marginBottom: 0,
    color: color.DANGER,
  },
};

// `role="alert"` so a validation failure is announced rather than only seen.
const QuestionErrorMessage = ({error, id}) => {
  if (isEmpty(error)) return null;

  return (
    <p id={id} role={'alert'} style={styles.errorMessage}>{error}</p>
  );
};

export default QuestionErrorMessage;
